import React from 'react'
import ReactTable from 'react-table-6'
import { Translate } from 'react-redux-i18n'
import { PriceExtended, PricesExtended, Signals, TradeCommandType } from '@bdswiss/mt4-connector'
import { FC, useContext } from 'react'
import { ExpandedAction, TableContext } from './contexts/TableContext'

export interface Props {
  row?: any
  assets: PricesExtended
  allSignals: Signals
  signal: any
  onSetSignal: (signal: any) => void
  onSetTradingSymbol: (symbol: string, tradeType: TradeCommandType) => void
}

interface ContentProps extends Props {
  expandedPositionsState: React.ReducerState<
    (state: { [p: string]: boolean }, action: ExpandedAction) => { [p: string]: boolean }
  >
  expandedPositionsDispatch: React.Dispatch<
    React.ReducerAction<
      (state: { [p: string]: boolean }, action: ExpandedAction) => { [p: string]: boolean }
    >
  >
}
export interface State {
  asset: PriceExtended
  signals: Map<number, any>
}

const AssetSignalsTable: FC<Props> = (props: Props) => {
  const { expandedPositionsState, expandedPositionsDispatch } = useContext(TableContext)
  return (
    <AssetSignalsTableContent
      {...props}
      expandedPositionsState={expandedPositionsState}
      expandedPositionsDispatch={expandedPositionsDispatch}
    />
  )
}

class AssetSignalsTableContent extends React.Component<ContentProps, State> {
  private columns = [
    {
      headerStyle: { display: 'none' },
      minWidth: 20,
      filterable: true,
      Cell: (props: any) => {
        const { id, direction } = props.original
        return (
          <div
            className={
              /up/i.test(direction) ? 'bdswiss-table--positive' : 'bdswiss-table--negative'
            }
            onClick={this.props.onSetSignal.bind(null, this.state.signals.get(id))}
            title={direction}
          >
            &nbsp;&nbsp;
            <i className={/up/i.test(direction) ? 'icon-buy-new' : 'icon-sell-new'} />
            <Translate value={direction} />
          </div>
        )
      },
    },
    {
      headerStyle: { display: 'none' },
      minWidth: 40,
      filterable: true,
      Cell: (props: any) => {
        const { id, pattern, keylevel } = props.original
        let type
        if (pattern) type = 'Chart Pattern'
        if (keylevel) type = 'Key Level'
        return (
          <div onClick={this.props.onSetSignal.bind(null, this.state.signals.get(id))} title={type}>
            {type}
          </div>
        )
      },
    },
    {
      headerStyle: { display: 'none' },
      minWidth: 40,
      filterable: true,
      Cell: (props: any) => {
        const { id, pattern, keylevel } = props.original
        let name
        if (pattern) name = pattern.name
        if (keylevel) name = keylevel.type
        return (
          <div onClick={this.props.onSetSignal.bind(null, this.state.signals.get(id))} title={name}>
            {name}
          </div>
        )
      },
    },
    // {
    //   headerStyle: { display: 'none' },
    //   id: 'id',
    //   accessor: 'id',
    //   minWidth: 30,
    //   filterable: true,
    //   Cell: (props: any) => {
    //     return (
    //       <div
    //         onClick={_ => this.props.onSetSignal(this.props.signals.get(props.value))}
    //         title={props.value}
    //         data-cy={props.value}
    //       >
    //         {props.value}
    //       </div>
    //     )
    //   },
    // },
    {
      headerStyle: { display: 'none' },
      id: 'complete',
      accessor: 'complete',
      minWidth: 30,
      filterable: true,
      Cell: (props: any) => {
        return (
          <div
            onClick={_ => this.props.onSetSignal(this.state.signals.get(props.original.id))}
            title={props.value.toString()}
            data-cy={props.value}
          >
            <Translate value={props.value ? 'complete' : 'emerging'} />
          </div>
        )
      },
    },
  ]

  constructor(props: ContentProps) {
    super(props)
    const asset = props.assets[props.row.symbol]
    const assetSignals = Object.values(props.allSignals)
      .filter(s => s.symbol === props.row.symbol)
      .reduce((acc, cur) => acc.set(cur.id, cur), new Map())

    this.state = {
      // showAll: false,
      asset: asset!,
      signals: assetSignals!,
    }
    this.toggleExpanded = this.toggleExpanded.bind(this)
  }

  public render() {
    const { signal, row, onSetTradingSymbol } = this.props
    const data = Array.from(this.state.signals.values())
    const length = data.length
    // const { showAll } = this.state
    if (!length) {
      return null
    }
    const showAll = row ? this.props.expandedPositionsState[row.symbol] : false
    return (
      <div className="InlinePositions" onClick={() => onSetTradingSymbol(row.symbol, 'buy')}>
        <div className="bdswiss-table--regular pad-20">
          {length} <Translate value={'signals'} />
        </div>
        <ReactTable
          data={data}
          columns={this.columns}
          className="bdswiss-table select-assets__table"
          showPagination={false}
          minRows={1}
          pageSize={showAll ? length : 3}
          sortable={false}
          resizable={false}
          collapseOnDataChange={false}
          defaultSorted={[
            {
              id: 'direction',
              desc: false,
            },
          ]}
          getTrProps={(state: any, rowInfo: any, col: any, instance: any) => {
            return rowInfo
              ? {
                  className: signal && rowInfo.original.id === signal.id ? 'active' : '',
                }
              : {}
          }}
        />
        {length > 3 ? (
          <div
            className="d-flex justify-content-center cursor-pointer text-primary"
            onClick={this.toggleExpanded}
          >
            <div className={'wt-expander wte-primary wte' + (showAll ? '-up' : '-down')}>
              &nbsp;
            </div>
            <button className="ButtonLink">
              <Translate value={showAll ? 'showLess' : 'showMore'} />
            </button>
          </div>
        ) : (
          undefined
        )}
      </div>
    )
  }

  private toggleExpanded() {
    const row = this.props.row
    if (row) {
      this.props.expandedPositionsDispatch({ type: 'toggle', key: row.symbol })
    }
  }
}

export default AssetSignalsTable
